/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { WineVisitorDto } from '../models/wine-visitor-dto';
@Injectable({
  providedIn: 'root',
})
class ExternalWineVisitorService extends __BaseService {
  static readonly postApiExternalWineVisitorPath = '/api/ExternalWineVisitor';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param body undefined
   * @return Success
   */
  postApiExternalWineVisitorResponse(body?: WineVisitorDto): __Observable<__StrictHttpResponse<WineVisitorDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/ExternalWineVisitor`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WineVisitorDto>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postApiExternalWineVisitor(body?: WineVisitorDto): __Observable<WineVisitorDto> {
    return this.postApiExternalWineVisitorResponse(body).pipe(
      __map(_r => _r.body as WineVisitorDto)
    );
  }
}

module ExternalWineVisitorService {
}

export { ExternalWineVisitorService }
